import React from "react";
import styled from "styled-components";
import colours from "../../lib/colours";
import { ReactComponent as DrawIcon } from "../../assets/svg/draw.svg";
import { ReactComponent as UploadIcon } from "../../assets/svg/upload.svg";

const iconSources: any[] = [DrawIcon, UploadIcon];

const iconStyles: any[] = [{ marginRight: "7px" }, { marginRight: "10px" }];

const TabsContainer = styled.div`
  height: 38px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${colours.offWhite};
  box-sizing: border-box;
`;

const TabButton = styled.button`
  display: flex;
  width: 50%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: ${colours.th1};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s linear;
`;

const TabButtonActive = styled(TabButton)`
  border: none;
  background-color: ${colours.th2};
  font-weight: 600;
`;

const TabButtonInactive = styled(TabButton)`
  border: 2px solid ${colours.th2l1};
  background-color: ${colours.white};
  font-weight: 500;
  &:hover {
    background-color: ${colours.th2l1};
  }
`;

interface IProps {
  names: string[];
  activeTab: number;
  setActiveTab: any;
}

const Tabs = ({ names, activeTab, setActiveTab }: IProps) => {
  return (
    <TabsContainer>
      {names.map((name, index) => {
        const Component =
          index === activeTab ? TabButtonActive : TabButtonInactive;
        const IconElement = iconSources[index];
        return (
          <Component
            key={index}
            onClick={() => {
              if (index !== activeTab) {
                setActiveTab(index);
              }
            }}
          >
            <IconElement style={iconStyles[index]} />
            {name}
          </Component>
        );
      })}
    </TabsContainer>
  );
};

export default Tabs;
